module.exports = __webpack_public_path__ + "img/xbsys3.1bb0d5e0.png";